import { addDoc, collection, deleteDoc, doc, getDocs, limit, onSnapshot, query, serverTimestamp, Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import { auth, db } from "../config/firebase";

export function usePinnedMessage(spotifyProfile) {
    const [pinnedMessage, setPinnedMessage] = useState(null);
  
    useEffect(() => {
      const pinnedRef = collection(db, 'pinned_messages');
      const pinnedQuery = query(pinnedRef, limit(1));
  
      const unsubscribe = onSnapshot(pinnedQuery, async (snapshot) => {
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          const data = { ...doc.data(), id: doc.id };
          setPinnedMessage(data);
        } else {
          setPinnedMessage(null);
        }
      });
  
      return () => unsubscribe();
    }, []);

    useEffect(() => {
      if (!pinnedMessage?.expiresAt) return;

      const checkInterval = setInterval(async () => {
        const expirationDate = pinnedMessage.expiresAt.toDate();
        if (expirationDate < new Date()) {
          console.log('Pin expired, removing...');
          await deleteDoc(doc(db, 'pinned_messages', pinnedMessage.id));
          setPinnedMessage(null);
        }
      }, 1000);

      return () => clearInterval(checkInterval);
    }, [pinnedMessage]);
  
    const pinMessage = async (message, durationSeconds = null) => {
      if (!auth.currentUser) return;
  
      try {
        const pinnedRef = collection(db, 'pinned_messages');
        const pinnedDocs = await getDocs(pinnedRef);
        await Promise.all(pinnedDocs.docs.map(doc => deleteDoc(doc.ref)));
  
        let expiresAt = null;
        if (durationSeconds) {
          expiresAt = Timestamp.fromMillis(
            Timestamp.now().toMillis() + (durationSeconds * 1000)
          );
          console.log('Setting expiration to:', expiresAt.toDate());
        }
  
        await addDoc(pinnedRef, {
          message: {
            text: message.text,
            userName: message.userName,
            userPhoto: message.userPhoto,
            currentTrack: message.currentTrack
          },
          pinnedAt: serverTimestamp(),
          expiresAt: expiresAt,
          pinnedBy: auth.currentUser.uid,
          pinnedByName: spotifyProfile.display_name,
          duration: durationSeconds
        });
      } catch (error) {
        console.error('Error pinning message:', error);
      }
    };
  
    const unpinMessage = async () => {
      if (!pinnedMessage?.id) return;
      
      try {
        await deleteDoc(doc(db, 'pinned_messages', pinnedMessage.id));
      } catch (error) {
        console.error('Error unpinning message:', error);
      }
    };
  
    return { pinnedMessage, pinMessage, unpinMessage };
}